import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { LINE_ITEMS_COLUMNS } from './LineItemsTable.config';
import styles from './LineItemsTable.styles.scss';
import { useTranslation } from 'react-i18next';

const LineItemsTable = ({ items, invoice }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={styles.container}>
      <DataTable
        scrollable
        scrollHeight="400px"
        value={items}
        tableStyle={{ minWidth: '50rem' }}
        className={styles['line-items-datatable']}
      >
        <Column header="#" body={(_rowData, idx) => idx.rowIndex + 1} />
        {LINE_ITEMS_COLUMNS(invoice, i18n.language).map((col, i) => (
          <Column
            key={col.key}
            field={col.key}
            body={col.body}
            header={t(col.label)}
            minWidth={'50rem'}
          />
        ))}
      </DataTable>
    </div>
  );
};

export default React.memo(LineItemsTable);
